/* eslint-disable */
import React, { useState } from "react";
import Select from "react-select";
import { useParams } from "react-router-dom";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { postData } from "utils/Gateway";

import contactOptions from "Data/ContactOptions.json";
import relationOptions from "Data/RelationOptions.json";

const ConnetModal = ({
  afterModalClose,
  token,
  personId,
  personName,
  setPersonId,
  setPersonName,
}) => {
  /* ---- state to select option values ---- */
  const [selectContactOption, setSelectContactOption] = useState(null);
  const [selectKnowingOption, setSelectKnowingOption] = useState(null);
  const [connectMessage, setConnectMessage] = useState("");
  const [isSending, setIsSending] = useState(false);

  /* ---- state to handle validation flags ---- */
  const [contactOptionError, setContactOptionError] = useState(false);
  const [knowingOptionError, setKnowingOptionError] = useState(false);
  const [connectMessageError, setConnectMessageError] = useState(false);

  /* ---- validation function ---- */
  const validateFields = () => {
    const contactError = !selectContactOption;
    const knowingError = !selectKnowingOption;
    const messageError = !connectMessage.trim();

    setContactOptionError(contactError);
    setKnowingOptionError(knowingError);
    setConnectMessageError(messageError);

    return !(contactError || knowingError || messageError);
  };

  //function for send request
  const sendConnectHandler = async () => {
    // Validate fields
    const isValid = validateFields();

    if (isValid) {
      setIsSending(true);
      try {
        let connectData = {
          member: personId,
          reason: selectContactOption?.value ? selectContactOption?.value : "",
          source: selectKnowingOption?.value ? selectKnowingOption?.value : "",
          message: connectMessage,
        };

        let requestURL =
          url.API_BASE_URL + url.API_SEND_REQUEST_USER + `?token=${token}`;

        // console.log(requestURL);
        const response = await postData(requestURL, connectData);

        setIsSending(false);
        // console.log(response);

        if (response.status) {
          // close the modal of addLabel
          resetHandler();
          let myModal = document.querySelector("#connect_modal");
          let modal = bootstrap.Modal.getInstance(myModal);
          modal.hide();

          afterModalClose();

          //show register modal
          //     let greetingModal = new bootstrap.Modal(
          //       document.getElementById("gretings_mdl")
          //     );
          //     greetingModal.show();
        }
      } catch (error) {
        error.message;
      }
    }
  };

  //reset function
  const resetHandler = () => {
    setSelectContactOption(null);
    setSelectKnowingOption(null);
    setConnectMessage("");
    setContactOptionError(false);
    setKnowingOptionError(false);
    setConnectMessageError(false);
    setPersonName("");
    setPersonId(null);
  };

  return (
    <div className="conatct_modal">
      <div
        className="modal fade"
        id="connect_modal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title">{personName}</h3>
              <button
                type="button"
                className="close rounded-circle"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={resetHandler}
              >
                <i className="material-icons-outlined text-black">close</i>
              </button>
            </div>
            <div className="modal-body">
              <div className="owner_detailsOuter">
                <div className="form-group mb-4">
                  <label className="fw-bold mb-3 text-black fs-md">
                    Select Contact Type
                  </label>
                  <Select
                    placeholder="Select Contact Type"
                    options={contactOptions}
                    value={selectContactOption}
                    onChange={(val) => setSelectContactOption(val)}
                  />
                  {contactOptionError && (
                    <p className="text-danger mb-0 mt-1">
                      * Please select a contact type.
                    </p>
                  )}
                </div>
                <div className="form-group mb-4">
                  <label className="fw-bold mb-3 text-black fs-md">
                    Select Contact Reason
                  </label>
                  <Select
                    placeholder="Select Relation"
                    options={relationOptions}
                    value={selectKnowingOption}
                    onChange={(val) => setSelectKnowingOption(val)}
                  />
                  {knowingOptionError && (
                    <p className="text-danger mb-0 mt-1">
                      * Please select a reason.
                    </p>
                  )}
                </div>
                <div className="form-group description_fill mb-4">
                  <label className="fw-bold mb-3 text-black fs-md">
                    Select Contact Message
                  </label>{" "}
                  <textarea
                    className="form-control bg_white"
                    placeholder="Message of contact"
                    value={connectMessage}
                    onChange={(e) => setConnectMessage(e.target.value)}
                  ></textarea>
                  {connectMessageError && (
                    <p className="text-danger mb-0 mt-1">
                      * Please enter a message.
                    </p>
                  )}
                </div>
              </div>

              <div className="post_btn">
                <button
                  className="btn"
                  disabled={isSending ? true : false}
                  style={{
                    cursor: isSending ? "not-allowed" : "pointer",
                  }}
                  onClick={sendConnectHandler}
                >
                  Send Request
                  {isSending && (
                    <div
                      className="mx-2 spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnetModal;
